import { render, staticRenderFns } from "./BuyFormModal.vue?vue&type=template&id=5d66446f"
import script from "./BuyFormModal.vue?vue&type=script&lang=js"
export * from "./BuyFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports